export default {
  top: [
    { url: "/profile", text: "Profile" },
    { url: "/notes", text: "Notes" },
    { url: "/weather", text: "Weather" },
    { url: "/calendar", text: "Calendar" },
    { url: "/about", text: "About" },
    { url: "/contact", text: "Contact" }
  ]
};
